class TableService {
  dedup(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i] === undefined || data[i] === "" || data[i] === " ") {
        data[i] = "NA";
      } else {
        data[i] = data[i]
          .replace(/\n/gi, "")
          .trimStart()
          .trimEnd();
      }
      let studyVals = data[i].split().map((d) => d);
      // find study values that contain a comma
      for (let s in studyVals) {
        if (studyVals[s].includes(",")) {
          let splitVals = studyVals[s].split(",").map((d) =>
            d
              .replace(/\n/gi, "")
              .trimStart()
              .trimEnd()
          );
          for (let j = 0; j < splitVals.length; j++) {
            let eachSplitVal = splitVals[j];
            data.push(eachSplitVal);
          }
          // Remove values with commas
          const indexOfStudyVals = data.indexOf(studyVals[s]);
          data.splice(indexOfStudyVals, 1);
        }
      }
    }
    // TODO, for some reason finding and removing the commas has to be done twice
    for (let i = 0; i < data.length; i++) {
      let studyVals = data[i].split().map((d) => d);
      for (let s in studyVals) {
        if (studyVals[s].includes(",")) {
          let splitVals = studyVals[s].split(",").map((d) =>
            d
              .replace(/\n/gi, "")
              .trimStart()
              .trimEnd()
          );
          for (let j = 0; j < splitVals.length; j++) {
            let eachSplitVal = splitVals[j];
            data.push(eachSplitVal);
          }
          // Remove values with commas
          const indexOfStudyVals = data.indexOf(studyVals[s]);
          data.splice(indexOfStudyVals, 1);
        }
      }
    }

    // DeDup again
    return [...new Set(data.map((v) => v.replace(/\n/gi, "").trimEnd()))];
  }
}

export const tableService = new TableService();
